import { MissionBoard } from '@/features/missions/ui/MissionBoard';

/**
 * §5: a page composes, it does not implement.
 */
export function MissionsPage() {
  return <MissionBoard />;
}
